import { useCallback } from "react";
import { useMapViewActions } from "@evergis/react";
import { Coordinates } from "@evergis/sgis/es/baseTypes";

import { useSharedProject } from "../../../hooks/sharing/useSharedProject";

export function useSharedProjectHomeView(): VoidFunction {
  const { content } = useSharedProject();
  const { position, resolution } = content;
  const { animateTo } = useMapViewActions();

  return useCallback(() => {
    if (position && resolution) {
      animateTo({
        position: position as Coordinates,
        resolution,
      });
    }
  }, [position, resolution, animateTo]);
}
